import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  listApiKeys,
  createApiKey,
  revokeApiKey,
  renameApiKey,
  type ApiKey,
  type ApiKeyWithSecret,
  type ApiKeyScope,
} from "../api/api-keys.api";
import { ApiError } from "@/lib/api/client";

export const apiKeysKeys = {
  all: ["api-keys"] as const,
  list: () => [...apiKeysKeys.all, "list"] as const,
};

export function useApiKeys() {
  return useQuery<ApiKey[], ApiError>({
    queryKey: apiKeysKeys.list(),
    queryFn: listApiKeys,
  });
}

export function useCreateApiKey() {
  const queryClient = useQueryClient();
  return useMutation<
    ApiKeyWithSecret,
    ApiError,
    { name: string; scopes: ApiKeyScope[]; expires_at?: string | null }
  >({
    mutationFn: createApiKey,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: apiKeysKeys.all });
    },
  });
}

export function useRevokeApiKey() {
  const queryClient = useQueryClient();
  return useMutation<ApiKey, ApiError, string>({
    mutationFn: revokeApiKey,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: apiKeysKeys.all });
    },
  });
}

export function useRenameApiKey() {
  const queryClient = useQueryClient();
  return useMutation<ApiKey, ApiError, { id: string; name: string }>({
    mutationFn: ({ id, name }) => renameApiKey(id, name),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: apiKeysKeys.all });
    },
  });
}
